<template>
	<div>
		<Header :sel='3' @changePhone="changePhone" />
		

			<!-- * 内页banner * -->
			<div class="page-banner">
				<img src="@/assets/images/banner06.png">
				<div class="nybt">
					<h3>项目案例</h3>
				</div>
			</div>
			
			<!-- * 当前位置 * -->
			<div class="page-position">
				<div class="wh">
					当前位置：
					<a href="/">首页</a>
					&gt;
					<a href="javascript:void(0)" @click="goBack">项目案例</a> >{{detail.title}}
				</div>
			</div>
			
			<!-- * 主体部分 * -->
			<div class="page-wrap">
				<div class="wh clearfix">
					<!-- * 左侧 * -->
			
			
					<!-- * 右侧 * -->
					<div class="page-wrap-right">
			
						<div class="xypg-left-con2 hidden-sm hidden-xs clearfix">
							<div>
							</div>
						</div>
			
			
			
						<div class="xypg-right-content">
							<!-- * 判断后台有没有录入多图 * -->
							<div>
								<!-- 产品详情页面 -->
								<div class="xypg-product-detail">
			
			
									<div class="product-detail-tab">
			
			
										<div class="product-detail-tabbox">
											<div class="product-detail-tabcon" v-html="detail.cmsArticleData?detail.cmsArticleData.content:''">
												
												
											</div>
										</div>
									</div>
								
								</div>
							</div>
			
							<!-- * 最近浏览 * -->
							<!-- * 最近浏览 * -->
			
			
						</div>
					</div>
			
					<!-- * 手机弹窗 * -->
			
				</div>
			</div>

			<Footer />



		<!--neirong-->


	</div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import axios from 'axios';


	import {
		articleDetail
	} from '@/api/reqFetch.js'

	export default {
		name: '',
		layout: '',
		components: {
			Footer,
			Header,
		},
		data() {
			return {
				id: '',
				detail: {},
				showPhone: false,
				pdfUrl: '',
				pdfDoc: null,
				pageNum: 1,
				pageCount: 0,
			}
		},

		mounted() {
			this.id = this.$route.query.id
			this.getNewDetail();
		},

		methods: {
			goBack(){
				this.$router.go(-1)
			},
			changePhone(val) {
				this.showPhone = val
			},
			getNewDetail() {
				articleDetail({
					id: this.id
				}).then(res => {
					this.detail = res.data;
					try {
							let cmsArticleData = this.detail.cmsArticleData
						if(cmsArticleData && cmsArticleData.content){
							// 正则替换空格&nbsp;为一个div元素，
							cmsArticleData.content = cmsArticleData.content.replace(/&nbsp;&nbsp;&nbsp;&nbsp;/g, '<div class="su-space"></div>')
						}
						this.detail = {
							...this.detail,
							cmsArticleData: cmsArticleData
						}
					} catch (error) {
						console.error(error)
					}
					this.fileList = res.data.fileList;
					if (res.data.fileList.length > 0 && res.data.fileList[0].fileExt == ".pdf") {
						// this.pdfUrl = res.data.fileList[0].url
						axios.get(res.data.fileList[0].url, {
							timeout: 60000,
							responseType: 'blob'
						}).then(res => {
							const binaryData = [];
							binaryData.push(res.data);
							let url = window.URL.createObjectURL(
								new Blob(binaryData, {
									type: "application/pdf"
								})
							)
							this.pdfUrl = url
						})

					}

				});
			},

			checkCategoryCode() {
				categorysortPage({
					pos: 'top'
				}).then(res => {
					if (this.level == 1) {
						res.data.map(item => {
							if (item.categoryCode == this.type) {
								this.selOneName = item.categoryName
								this.configList = item.children
							}
						})
					} else {
						res.data.map(item => {
							if (item.categoryCode == this.firstCategoryCode) {
								this.selOneName = item.categoryName
								this.configList = item.children
								this.configList.map(items => {
									if (items.categoryCode == this.type) {
										this.selName = items.categoryName
									}
								})
							}
						})
					}

				});
			},

		}
	}
</script>

<style scoped>
	/*内容*/
	.banner {
		/* background-image: url('../../assets/images/banner_03.png'); */
	}

</style>